<template>
  <j-modal
    :title="title"
    :width="600"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-spin :spinning="loading">
      <a-form-model ref="form" :model="form" @keyup.enter.native="handleOk" :rules="rules">
        <a-form-model-item prop="roleCode" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <span slot="label" class="required">角色编号</span>
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.roleCode')])"
            v-model="form.roleCode"
            :maxLength="100"
            :disabled="form.id"
          />
        </a-form-model-item>

        <a-form-model-item prop="roleName" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <span slot="label" class="required">角色名称</span>
          <a-input :placeholder="$t('disp.ph.input', [$t('disp.roleName')])" v-model="form.roleName" :maxLength="200" />
        </a-form-model-item>

        <a-form-model-item
          :label="this.$t('disp.note')"
          prop="description"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            @keyup.enter.stop
            :autoSize="{ minRows: 1 }"
            :placeholder="$t('disp.ph.input', [$t('disp.note')])"
            v-model="form.description"
            :maxLength="255"
          />
        </a-form-model-item>

        <a-form-model-item label="系统角色" prop="systemFlag" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch :checkedChildren="$t('disp.yes')" :unCheckedChildren="$t('disp.no')" v-model="form.systemFlag" />
        </a-form-model-item>

        <a-form-model-item label="可在入职流程选择" prop="entryFlag" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch :checkedChildren="$t('disp.yes')" :unCheckedChildren="$t('disp.no')" v-model="form.entryFlag" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import pick from 'lodash/pick'
import { addRole, editRole, duplicateCheck } from '@/api/api'

class formDef {
  id = undefined
  roleCode = undefined
  roleName = undefined
  description = undefined
  systemFlag = false
  entryFlag = false
}

export default {
  name: 'RoleModal',
  data() {
    return {
      title: '',
      loading: false,
      visible: false,
      roleDisabled: false,
      form: new formDef(),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      rules: {
        roleCode: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback('请填写必须项目')
              } else if (/[^\a-\z\A-\Z0-9]/g.test(value)) {
                callback(this.$t('disp.rules.halfCharNum'))
              } else {
                var params = {
                  tableName: 'sys_role',
                  fieldName: 'role_code',
                  fieldVal: value,
                  dataId: this.form.id,
                }
                duplicateCheck(params).then((res) => {
                  if (res.success) {
                    callback()
                  } else {
                    callback(this.$t('disp.rules.duplicate', [this.$t('disp.roleCode')]))
                  }
                })
              }
            },
            trigger: 'change',
          },
        ],
        roleName: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback('请填写必须项目')
              } else {
                var params = {
                  tableName: 'sys_role',
                  fieldName: 'role_name',
                  fieldVal: value,
                  dataId: this.form.id,
                }
                duplicateCheck(params).then((res) => {
                  if (res.success) {
                    callback()
                  } else {
                    callback(this.$t('disp.rules.duplicate', [this.$t('disp.roleName')]))
                  }
                })
              }
            },
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({}, false)
    },
    edit(record, isAdd) {
      this.visible = true

      // 使用form定义初始化form
      this.form = new formDef()

      // 新增
      if (isAdd) {
      }
      // 编辑
      else {
        Object.assign(this.form, record)
      }
    },
    handleOk() {
      // 表单验证
      this.$refs.form.validateFieldsAndScroll((ok) => {
        // 验证成功
        if (ok) {
          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          let obj
          if (!this.form.id) {
            obj = addRole(this.form)
          } else {
            obj = editRole(this.form)
          }
          obj
            .then((res) => {
              if (res.success) {
                this.$message.success('处理成功')
                this.visible = false
                this.$emit('emit')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleCancel() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>

<style scoped lang="less"></style>
